import { Accordion, AccordionTab } from 'primereact/accordion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './FilterWrapper.css';

type Props = {
    filterComponent: React.ReactNode;
};

const FilterWrapper = ({ filterComponent }: Props) => {
    const { t } = useTranslation();
    return (
        <Accordion activeIndex={0} className='filter-wrapper'>
            <AccordionTab header={t('filtering')}>{filterComponent}</AccordionTab>
        </Accordion>
    );
};

export default FilterWrapper;
